__turbopack_context__.v({
  "className": "poppins_bc9382f7-module__t2obLW__className",
});
